import React from 'react';
import { motion } from 'framer-motion';
interface SlideInProps {
  children: React.ReactNode;
  direction?: 'left' | 'right' | 'up' | 'down';
  delay?: number;
  duration?: number;
  className?: string;
}
export const SlideIn = ({
  children,
  direction = 'up',
  delay = 0,
  duration = 0.5,
  className
}: SlideInProps) => {
  const directions = {
    left: {
      x: -20,
      y: 0
    },
    right: {
      x: 20,
      y: 0
    },
    up: {
      x: 0,
      y: 20
    },
    down: {
      x: 0,
      y: -20
    }
  };
  return <motion.div initial={{
    opacity: 0,
    ...directions[direction]
  }} animate={{
    opacity: 1,
    x: 0,
    y: 0
  }} transition={{
    duration,
    delay,
    ease: 'easeOut'
  }} className={className} data-id="element-60" data-mp="33mp8o62rxbpi">
      {children}
    </motion.div>;
};